import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsLink } from '@/learnpaths/components/LearnpathsAddElementsLink/LearnpathsAddElementsLink'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(link)/update/link/$elementId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <LearnpathsAddElementsLink mode="update" />
}
